import {getPdfReport} from "../../api";
import {downloadFullPdfReport} from "../../api/Pdf"
import Button from "../../components/Button";
import React, {Component} from "react";
import SpinnerNew from "../../components/Spinner/SpinnerNew";


class PdfReport extends Component {

    constructor(props) {
        super(props);
        this.handlePDFReport = this.handlePDFReport.bind(this);
        //this.base64ToArrayBuffer = this.base64ToArrayBuffer.bind(this);
        //this.downloadToClient = this.downloadToClient.bind(this);
        this.handleErrors = this.handleErrors.bind(this);
    }

    state = {
        error: null,
        project: this.props.project,
        dataPdfReport:"",
        pdfBtn:false,
        spinnerOn: false
    }

    async handlePDFReport(){
        this.setState({'spinnerOn': true});
        document.getElementById('pdf-button').classList.add('disabledbutton');
        //let dateStr = this.formatDate();
        //let response = await getPdfReport(this.props.project.id, dateStr);
        //this.downloadToZipFile(response);
        await downloadFullPdfReport(this.props.project.id);
        document.getElementById('pdf-button').classList.remove('disabledbutton');
        this.setState({'spinnerOn': false});
    }

    handleErrors(error){
        this.setState({error});
        window.scrollTo(0,0);
    }
    render() {
        if (this.props.project.projectStatus === 'C') {
            return (
                <>
                    <SpinnerNew display={this.state.spinnerOn}/>
                    <Button id="pdf-button" onClickHandler={this.handlePDFReport}>Final PDF Report</Button>
                </>
            );
        }else{
            return (
                <>
                    <SpinnerNew display={this.state.spinnerOn}/>
                    <Button id="pdf-button" onClickHandler={this.handlePDFReport}>PDF Report</Button>
                </>
            );
        }
    }
}

export default PdfReport;